export const defaultCartSectionsModelData = {
  scrolledToTitle: false
};

export const ActionType = {
  CLEAR: `CLEAR`,
  SCROLL_TO_TITLE: `SCROLL_TO_TITLE`
};
